import script from "./success.vue?vue&type=script&setup=true&lang=js"
export * from "./success.vue?vue&type=script&setup=true&lang=js"

import "./success.vue?vue&type=style&index=0&id=d7719e96&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/h5-subscription-client-prod-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7719e96"]])

export default __exports__